import { Component } from '@angular/core';
import { MAPSPersonQualificationFactsEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Person Qualification Facts') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapspersonqualificationfacts-form',
    templateUrl: './mapspersonqualificationfacts.form.component.html'
})
export class MAPSPersonQualificationFactsFormComponent extends BaseFormComponent {
    public record!: MAPSPersonQualificationFactsEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

